export const MainDashboardContentDomID = "main-dashboard-content";
